import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser'
import Banner from './Banner'
import Serviceblock from './Serviceblock'
import Services from './Services'
import Counter from './Counter'
import About from './About'
// import Success from './Success'
import Portfolio from './Portfolio'
import Testimonial from './Testimonial'
import Callus from './Callsus'
import withRouter from '../withRouter'
import Brands from '../Innerpage/Brands'
// import Blog from './Blog'

class Home extends Component {

  constructor() {
    super();
    this.state = {
      banners: {},
      allservices: [],
      ms: [],
      abouttext: [],
      our_work: [],
      callustext: [],
      yoasthead: '',
      services_blocks: []
    }
  }


  async componentDidMount() {    
    

    await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/wp/v2/pages/18`).then((response) => {
      response.json().then((res) => {

        this.setState({
          banners: {
            banner_heading: res.acf.banner_1.banner_heading,
            contact_button_text: res.acf.banner_1.contact_button_text,
            contact_button_link: res.acf.banner_1.contact_button_link,
            banner_bkimage: res.acf.banner_1.banner_image
          },
          yoasthead: res.yoast_head.replaceAll("rcweb.", ""),
          allservices: [
            {
              more_info_link: res.acf.service_1.more_info_link.replace("https://rcweb.kanopuswebsolutions.com", ""),
              service_content: res.acf.service_1.service_content,
              service_image: res.acf.service_1.service_image,
              service_name: res.acf.service_1.service_name
            },
            {
              more_info_link: res.acf.service_2.more_info_link.replace("https://rcweb.kanopuswebsolutions.com", ""),
              service_content: res.acf.service_2.service_content,
              service_image: res.acf.service_2.service_image,
              service_name: res.acf.service_2.service_name
            },
            {
              more_info_link: res.acf.service_3.more_info_link.replace("https://rcweb.kanopuswebsolutions.com", ""),
              service_content: res.acf.service_3.service_content,
              service_image: res.acf.service_3.service_image,
              service_name: res.acf.service_3.service_name
            },
            {
              more_info_link: res.acf.service_4.more_info_link.replace("https://rcweb.kanopuswebsolutions.com", ""),
              service_content: res.acf.service_4.service_content,
              service_image: res.acf.service_4.service_image,
              service_name: res.acf.service_4.service_name
            },
            {
              more_info_link: res.acf.service_5.more_info_link.replace("https://rcweb.kanopuswebsolutions.com", ""),
              service_content: res.acf.service_5.service_content,
              service_image: res.acf.service_5.service_image,
              service_name: res.acf.service_5.service_name
            },
            {
              more_info_link: res.acf.service_6.more_info_link.replace("https://rcweb.kanopuswebsolutions.com", ""),
              service_content: res.acf.service_6.service_content,
              service_image: res.acf.service_6.service_image,
              service_name: res.acf.service_6.service_name
            }
          ],
          abouttext: {
            "welcome_text": res.acf.welcome_text,
            "about_heading": res.acf.about_heading,
            "about_us_content": res.acf.about_us_content,
            "know_more_btn_text": res.acf.know_more_btn_text,
            "know_more_btn_link": res.acf.know_more_btn_link,
            "about_image_one": res.acf.about_image_one,
            "about_image_two": res.acf.about_image_two,
          },
          ms: [
            {
              id:1,
              milestone_number: res.acf.milestone_1.milestone_number,
              milestone_text: res.acf.milestone_1.milestone_text,
              milestone_icon: res.acf.milestone_1.milestone_icon
            },
            {
              
              milestone_number: res.acf.milestone_2.milestone_number,
              milestone_text: res.acf.milestone_2.milestone_text,
              milestone_icon: res.acf.milestone_2.milestone_icon
            },
            {
              id:3,
              milestone_number: res.acf.milestone_3.milestone_number,
              milestone_text: res.acf.milestone_3.milestone_text,
              milestone_icon: res.acf.milestone_3.milestone_icon
            },
            {
              id:4,
              milestone_number: res.acf.milestone_4.milestone_number,
              milestone_text: res.acf.milestone_4.milestone_text,
              milestone_icon: res.acf.milestone_4.milestone_icon
            }
          ],
          our_work:[ res.acf.our_work_image_1, res.acf.our_work_image_2, res.acf.our_work_image_3, res.acf.our_work_image_4 ],
          callustext: {
             contactline: res.acf.contact_us_line,
             btntext: res.acf.contact_us_button_text,
             btnlink: res.acf.contact_us_btn_link.replace("https://rcweb.kanopuswebsolutions.com", "")
            },
          services_blocks:[ res.acf.services_block_1, res.acf.services_block_2, res.acf.services_block_3, res.acf.services_block_4 ],
        })

      })

    })
  }



  render() {
    
    return (
      
      <>
        <Helmet>
          {parse("<>" + this.state.yoasthead + "<>")}
        </Helmet>
        <Banner bannerdetail={this.state.banners} />
        <Serviceblock sblocks={this.state.services_blocks} />
        <About aboutcontent={this.state.abouttext} />
        <Counter ms={this.state.ms} />
        <Services allservices={this.state.allservices} />
        {/* <Success /> */}
        <Portfolio ourwork={this.state.our_work} />
        <Testimonial /> 
        <Brands />
        
        {/* <Blog /> */}
        <Callus callt={this.state.callustext} />
      </>
    )
  }
}

export default withRouter(Home);